module.exports = __webpack_public_path__ + "html/comments_a9973519437284a57f50a0a9647fdc78.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/project/comments/comments.html
// module id = wTNS
// module chunks = 118